import {generate, memoize} from 'helpers';

// attach random ids that can be used by reducers
export function generateIds() {
  return next => action => {
    let id = generate();
    next({
      ...action,
      generateId: memoize(name => {
        if (/^_/.test(name)) {
          return '_' + id++;
        }
        return id++;
      }),
    });
  }
}
